import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService, CommonPortalUrlService } from 'gast-portal-ng';
import { TranslationService, Product } from 'gast-common-ng';
var AuthGuard = /** @class */ (function () {
    function AuthGuard(http, authService, commonPortalUrlService, translationService) {
        this.http = http;
        this.authService = authService;
        this.commonPortalUrlService = commonPortalUrlService;
        this.translationService = translationService;
    }
    AuthGuard.prototype.canActivate = function () {
        var _this = this;
        return this.http.get(this.commonPortalUrlService.getUserInfo(), { withCredentials: true }).pipe(map(function (response) {
            if (response && response.name) {
                _this.authService.saveUserObjectInStorage(response.name, response.principal.longusername);
                return true;
            }
            else {
                return _this.handleNotLoggedIn();
            }
        }), catchError(function (err) {
            console.log('failed to retrieve user-info', err);
            return of(false);
        }));
    };
    AuthGuard.prototype.handleNotLoggedIn = function () {
        this.authService.saveUserObjectInStorage(null, null);
        window.location.href = this.commonPortalUrlService.
            getPortalAccountLoginUrl(Product.ONSET, this.translationService);
        return false;
    };
    return AuthGuard;
}());
export { AuthGuard };
